import React, {
  Component,
  PropTypes
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import HomeComponent from 'components/HomeComponent';

function mapStateToProps(state, ownProps) {
  /* Populated by react-webpack-redux:reducer */
  const props = {
    workoutData: state.workoutData,
    trybeName: state.analyticsReducer.get('trybeName')
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  /* Populated by react-webpack-redux:action */
  const actions = {
    signUpActions: require('../actions/signUpActions.js')
  };
  const actionMap = {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeComponent);



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js